import * as React from "react";
import theme from "./utils/theme";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import Layout from "./pages/layout";
import userHandler, { IUser } from "./utils/userHandler";
import { Provider } from "react-redux";
import createStore, { AppDispatch, IStore } from "./store";
import { Store } from "redux";
import SnackBar from "./components/snackbar";
import { AuthActions } from "./store/auth/auth-actions";
import "bootstrap/dist/css/bootstrap.css";
import "react-block-ui/style.css";

import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import DateFnsUtils from "material-ui-pickers/utils/date-fns-utils";
import * as es from "date-fns/locale/es";
import { buildApi, getApi } from "./api/ApiProvider";

interface AppState {
  logged: boolean;
}

class App extends React.Component<any, AppState> {
  private readonly store: Store<IStore> & { dispatch: AppDispatch };

  constructor(props: any) {
    super(props);
    this.store = createStore();

    console.log("STORE INIT", this.store.getState());
    buildApi(this.store.getState().config.data.api);

    getApi().notifyLogin(userHandler.getToken());
    getApi().addErrorHandler((err) => {
      console.log("handling err", err);
      if (err.status === 401) {
        this.store.dispatch(new AuthActions().logout());
        throw err;
      }
      if (err.status === 504) {
        console.log("backend not available");
      }
      return false;
    });

    /**
     * This handles the login/logout of the user
     */
    this.store.subscribe(() => {
      const state = this.store.getState();
      const auth = state.auth;
      const config = state.config;

      getApi().notifyNewUrl(config.data.api);

      const newState = !!auth.user;
      // no change detected
      if (newState === this.state.logged) {
        return;
      }

      if (newState && auth.user) {
        this.handleLogin(auth.user);
      } else {
        this.handleLogout();
      }
    });

    this.state = {
      logged: userHandler.isLogged(),
    };
  }

  handleLogin = (user: IUser) => {
    getApi().notifyLogin(user.token);
    userHandler.notifyLogin(user);
    this.setState({ logged: true });
  };

  handleLogout = () => {
    userHandler.logout();
    getApi().notifyLogout();
    this.setState({ logged: false });
  };

  render() {
    const isLogged = this.state.logged;
    return (
      <Provider store={this.store}>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
            <SnackBar />
            <Layout isLogged={isLogged} {...this.props} />
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx